module.exports = __webpack_public_path__ + "static/media/fujiyama.16f41cdf.webp";